import React from 'react';
import { connect } from 'react-redux';

import { toggleModal, toggleSpinner } from 'apps/auth/actions/appAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const DocumentExpiringModal = (props) => {
    const { notNowButton, continueButton } = usePageMessages();
    const { canCloseModal = true } = props;
    return (
        <ModalComponent isVerticalCentered canCloseModal={canCloseModal}>
            <InfoPage
                insideModalComponent
                iconName="id-card-80"
                iconColor="primary"
                topButtonCaption={notNowButton}
                topButtonOnClick={() => {
                    props.toggleModal(false);
                }}
                primaryButtonCaption={continueButton}
                primaryButtonType={'link'}
                primaryButtonLink={props.url}
                headerText={props.headerText}
                secondaryText={props.description}
                primaryButtonOnClick={() => {
                    props.toggleSpinner(true);
                }}
            />
        </ModalComponent>
    );
};
export default connect(null, { toggleModal, toggleSpinner })(DocumentExpiringModal);
